// Please see documentation at https://learn.microsoft.com/aspnet/core/client-side/bundling-and-minification
(function () {
    'use strict';
    // Remove any legacy toast containers that may exist in DOM from older bundles
    try {
        var _legacyIds = ['toast-stack', 'notify-toast-container', 'notify-toast', 'global-notify-container'];
        _legacyIds.forEach(function(id) { try { var el = document.getElementById(id); if (el) { el.remove(); console.debug('[site] removed legacy container', id); } } catch(e) {} });
    } catch (e) { }

    // Also watch for any future addition of legacy containers (some other script may add them)
    try {
        var legacyObserver = new MutationObserver(function(muts) {
            muts.forEach(function(m) {
                if (!m.addedNodes) return;
                m.addedNodes.forEach(function(n) {
                    try {
                        if (!(n instanceof Element)) return;
                        var id = (n.id || '').toString();
                        if (id === 'toast-stack' || id === 'notify-toast-container' || id === 'notify-toast' || id === 'global-notify-container') {
                            try { n.remove(); console.debug('[site][observer] removed legacy container on add', id); } catch (e) {}
                        }
                        // also check descendants
                        var found = n.querySelector && (n.querySelector('#toast-stack, #notify-toast-container, #notify-toast, #global-notify-container'));
                        if (found) {
                            try { found.remove(); console.debug('[site][observer] removed legacy descendant container'); } catch (e) {}
                        }
                    } catch (e) {}
                });
            });
        });
        legacyObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
        // keep observing (do not disconnect) and log when legacy container is re-introduced
        // If a legacy container appears, log diagnostic info to help find the source and remove it.
        // Note: leave observer active for the page lifetime
    } catch (e) {}

    // Diagnostic observer: if legacy #toast-stack appears, log scripts and stack and remove it
    try {
        var diagObserver = new MutationObserver(function(muts) {
            muts.forEach(function(m) {
                if (!m.addedNodes) return;
                m.addedNodes.forEach(function(n) {
                    try {
                        if (!(n instanceof Element)) return;
                        if (n.id === 'toast-stack' || n.querySelector && n.querySelector('#toast-stack')) {
                            console.warn('[site][diag] legacy toast-stack appeared, removing.');
                            try { console.warn('[site][diag] Current scripts:', Array.from(document.scripts).map(s=>s.src).filter(Boolean)); } catch (e) {}
                            try { console.warn('[site][diag] Creation stack:', (new Error()).stack); } catch (e) {}
                            try { n.remove(); } catch (e) {}
                        }
                    } catch (e) {}
                });
            });
        });
        diagObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
    } catch (e) {}
    // Mark that JavaScript is enabled so CSS reveal rules are only applied when JS runs. 
    try { document.documentElement.classList.add('js-enabled'); } catch (e) { /* ignore */ }
    // Immediately remove any page-level elements that contain the push-consent text so they
    // don't appear alongside the global consent toast. Run synchronously as the script loads.
    (function removeImmediateConsentDuplicates(){
        try{
            var snippets = [
                'Enable browser notifications to receive push messages',
                'Use the browser UI to allow notifications'
            ];
            var keepIds = ['global-notify-toast','global-notify-container','notify-toast','notify-toast-container'];
            var candidates = Array.from(document.querySelectorAll('.toast, .alert, [role="alert"], .notification, .notify'));
            candidates.forEach(function(el){
                try{
                    if(!el || !el.textContent) return;
                    var txt = el.textContent.trim();
                    if(!txt) return;
                    var match = snippets.some(function(s){ return txt.indexOf(s) !== -1; });
                    if(match){
                        var id = (el.id || '').toString();
                        if(keepIds.indexOf(id) !== -1) return; // preserve global toast
                        // remove duplicate element
                        el.remove();
                        console.debug('[site] removed duplicate consent element', el);
                    }
                }catch(e){}
            });
        }catch(e){}
    })();


    // Global consent toast removed — handlers cleaned up.

    // Centralized toast container (always present in layout)
    // Always use only the main-toast-container from layout, never create toast-stack
    function ensureToastContainer() {
        var container = document.getElementById('main-toast-container');
        if (!container) {
            // fallback: if layout is missing the container, create it once
            container = document.createElement('div');
            container.id = 'main-toast-container';
            container.className = 'toast-container position-fixed bottom-0 end-0 p-3';
            document.body.appendChild(container);
        }
        // Remove legacy container if present
        try {
            var legacy = document.getElementById('toast-stack');
            if (legacy && legacy !== container) legacy.remove();
        } catch (e) { }
        return container;
    }


    // Consent toast logic: show only once per user/session, with delay, and treat any close as dismissed
    function showConsentToastIfNeeded() {
        try {
            if (!('Notification' in window)) return;
            var dismissed = localStorage.getItem('global_notify_shown_v1') === '1';
            if (dismissed) return;
            if (Notification.permission !== 'default') return;
            // Show only once per session (prevent multiple per page load)
            if (sessionStorage.getItem('consent_toast_shown') === '1') return;
            sessionStorage.setItem('consent_toast_shown', '1');
            setTimeout(function() {
                // Double-check before showing
                var dismissed = localStorage.getItem('global_notify_shown_v1') === '1';
                if (dismissed) return;
                if (Notification.permission !== 'default') return;
                var t = window.toasts.show('Info', 'Enable browser notifications to receive push messages. Use the browser UI to allow notifications when ready.', 'info', { consent: true, persistent: true, delay: 0 });
                // Treat any close (X, Allow, No thanks, timeout) as dismissed
                t._consentWired = true;
            }, 4000);
        } catch (e) { }
    }

    // Global helper to dismiss the consent toast reliably from any script.
    window.dismissGlobalNotify = function() {
        try {
            try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) { }
            try { window.__globalNotifyDismissed = true; } catch (e) { }
            var el = document.getElementById('global-notify-toast');
            if (el) {
                try {
                    if (window.bootstrap) {
                        try { bootstrap.Toast.getOrCreateInstance(el).hide(); } catch { }
                    } else {
                        el.classList.remove('show');
                        el.style.display = 'none';
                    }
                } catch (e) { }
            }
        } catch (e) { /* swallow */ }
    };

    (function () {
        const key = 'theme-preference';
        const html = document.documentElement;
        const btn = document.getElementById('theme-toggle');
        function current() { return html.getAttribute('data-bs-theme') || 'light'; }
        function set(t) { html.setAttribute('data-bs-theme', t); html.setAttribute('data-theme', t); try { localStorage.setItem(key, t); } catch { } }
        function icon() { if (btn) btn.textContent = current() === 'dark' ? '☀️' : '🌙'; }
        // restore stored preference if present
        try {
            const stored = localStorage.getItem(key);
            if (stored) set(stored);
        } catch (e) { /* ignore */ }
        icon();
        if (btn) {
            btn.addEventListener('click', function () {
                set(current() === 'light' ? 'dark' : 'light');
                icon();
            });
        }
    })();

// Ensure global consent toast buttons are wired (idempotent) so Allow/No-thanks always work
document.addEventListener('DOMContentLoaded', function () {
    try {
        var toastEl = document.getElementById('global-notify-toast');
        console.log('[site] DOMContentLoaded wiring global notify', { toastEl: !!toastEl });
        if (!toastEl) return;
        var btnAllow = document.getElementById('global-notify-allow');
        var btnDeny = document.getElementById('global-notify-deny');
        var bs = (window.bootstrap) ? new bootstrap.Toast(toastEl, { autohide: false }) : null;

        if (btnAllow && !btnAllow.dataset._wired) {
            btnAllow.addEventListener('click', async function () {
                try { const p = await Notification.requestPermission(); if (p === 'granted') { try { if (window.startNotifications) await window.startNotifications(); } catch (e) {} } } catch (e) {}
                try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                try { if (bs) bs.hide(); else { toastEl.classList.remove('show'); toastEl.style.display = 'none'; } } catch (e) {}
            });
            btnAllow.dataset._wired = '1';
        }

        if (btnDeny && !btnDeny.dataset._wired) {
            btnDeny.addEventListener('click', function () {
                try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                try { if (bs) bs.hide(); else { toastEl.classList.remove('show'); toastEl.style.display = 'none'; } } catch (e) {}
            });
            btnDeny.dataset._wired = '1';
        }

        // show toast if not dismissed
        try {
            var dismissed = false;
            try { dismissed = localStorage.getItem('global_notify_shown_v1') === '1'; } catch (e) { dismissed = false; }
            if (!dismissed) {
                if (bs) bs.show(); else { toastEl.classList.add('show'); toastEl.style.display = 'block'; }
            }
        } catch (e) { }
    } catch (e) { }
});

    // Service worker registration (safe)
    (function () {
        if (!('serviceWorker' in navigator)) return;

        window.addEventListener('load', async () => {
            try {
                const isSecure =
                    window.isSecureContext ||
                    location.protocol === 'https:' ||
                    location.hostname === 'localhost' ||
                    location.hostname === '127.0.0.1';

                if (!isSecure) {
                    console.log('[SW] Skipped: insecure context.');
                    return;
                }
                const swUrl = '/sw.js';
                const res = await fetch(swUrl, { method: 'HEAD', cache: 'no-store' });
                if (!res.ok) {
                    console.log('[SW] Not found on this origin, skipping.');
                    return;
                }
                const reg = await navigator.serviceWorker.register(swUrl, { scope: '/' });
                console.log('[SW] Registered:', reg.scope);
            } catch (err) {
                console.warn('[SW] Registration skipped:', err);
            }
        });
    })();

    // Unified share helper (slug or id)
    window.shareContent = async function shareContent(title = '', text = '', slugOrId = '', mode = 'slug') {
        // Basic validation: if missing or empty, fall back to current page URL
        if ((!slugOrId || typeof slugOrId !== 'string' || slugOrId.trim() === '')) {
            console.warn('[shareContent] Missing slug/id. Falling back to current page URL.');
            slugOrId = window.location.href;
            mode = 'url';
        }
        // If slugOrId looks like an absolute URL, use it directly
        const isAbsoluteUrl = /^https?:\/\//i.test(slugOrId) || slugOrId.startsWith(window.location.origin);
        // Build link
        let link;
        if (isAbsoluteUrl) {
            link = slugOrId;
        } else if (mode === 'id') {
            // legacy id-based path
            link = window.location.origin + '/Shared/' + encodeURIComponent(slugOrId);
        } else if (mode === 'url') {
            // treat slugOrId as an absolute or root-relative URL
            if (slugOrId.startsWith('/')) link = window.location.origin + slugOrId;
            else link = slugOrId;
        } else { // default: treat as slug and point to Post page
            link = window.location.origin + '/Post?slug=' + encodeURIComponent(slugOrId);
        }
        // Prefer Web Share API when available
        if (navigator.share) {
            const payload = { title: title || document.title, text: text || '', url: link };
            try {
                if (navigator.canShare && !navigator.canShare(payload)) {
                    throw new Error('Browser reports payload not shareable.');
                }
                await navigator.share(payload);
                console.log('[shareContent] Shared:', link);
                return true;
            } catch (err) {
                console.error('[shareContent] Share API failed, falling back:', err);
            }
        }
    };
    // Delegated handler for share buttons (uses data attributes on the button)
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.share-btn-water');
        if (!btn) return;
        try {
            var title = btn.dataset.shareTitle || '';
            var text = btn.dataset.shareText || '';
            var url = btn.dataset.shareUrl || '';
            // Call shareContent; let it fallback to current page if url empty
            shareContent(title, text, url, 'url');
        } catch (err) {
            console.error('[shareContent] Error invoking share:', err);
        }
    });

    // Page reveal animations (staggered)
    (function () {
        function revealOnLoad() {
            const ordered = [];
            const mainChildren = Array.from(document.querySelectorAll('main > *:not(script):not(style)'));
            if (mainChildren.length)
                ordered.push(...mainChildren);
            const extras = Array.from(document.querySelectorAll('main .card, main .list-group, main .table'));
            extras.forEach(el => {
                if (!ordered.includes(el)) ordered.push(el);
            });
            if (ordered.length === 0) {
                const main = document.querySelector('main');
                if (main)
                    ordered.push(main);
            }
            ordered.forEach(el => el.classList.add('reveal'));
            ordered.forEach((el, i) => {
                const delay = Math.min(80 * i, 700);
                setTimeout(() => el.classList.add('visible'), delay);
            });
            var mainReveal = document.querySelector('main.reveal-inside');
            if (mainReveal) {
                mainReveal.classList.add('reveal-inside');
                setTimeout(function () { mainReveal.classList.add('visible'); }, 120);
            }
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', revealOnLoad);
        } else {
            revealOnLoad();
        }
    })();



    // Bootstrap Toast helper (single, themed, elegant)
    window.toasts = {
        show: function (title, body, type, opts) {
            var container = ensureToastContainer();
            var id = 't' + Date.now();
            // avoid duplicate toasts with same body and title
            try {
                var existing = Array.from(container.querySelectorAll('.toast'))
                    .find(t => {
                        try {
                            var h = t.querySelector('.toast-header strong');
                            var b = t.querySelector('.toast-body');
                            var ht = h ? h.textContent.trim() : '';
                            var bt = b ? b.textContent.trim() : '';
                            return ht === (title || 'Notice') && bt === (body || '');
                        } catch (e) { return false; }
                    });
                if (existing) {
                    try { var tinst = new bootstrap.Toast(existing); tinst.show(); } catch (e) { }
                    return existing;
                }
            } catch (e) { /* ignore */ }
            var wrapper = document.createElement('div');
            wrapper.className = 'toast align-items-center border-0 shadow glass ' + (type || 'info');
            wrapper.setAttribute('role', 'status');
            wrapper.setAttribute('aria-live', 'polite');
            wrapper.setAttribute('aria-atomic', 'true');
            wrapper.id = id;
            var header = '<div class="toast-header">' +
                ' <strong class="me-auto">' + (title || 'Notice') + '</strong>' +
                ' <small class="text-muted">now</small>' +
                ' <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>' +
                '</div>';
            var bodyHtml = '<div class="toast-body">' + (body || '') + '</div>';
            // Consent toast special case
            if (opts && opts.consent) {
                bodyHtml = '<div class="toast-body d-flex align-items-center justify-content-between">' +
                    '<div>' + (body || '') + '</div>' +
                    '<div class="btn-group btn-group-sm ms-3">' +
                    '<button id="global-notify-allow" class="btn btn-primary">Allow</button>' +
                    '<button id="global-notify-deny" class="btn btn-outline-secondary">No thanks</button>' +
                    '</div></div>';
            }
            wrapper.innerHTML = header + bodyHtml;
            container.appendChild(wrapper);
            var t = new bootstrap.Toast(wrapper, { delay: (opts && opts.delay) || 4000, autohide: !(opts && opts.persistent) });
            t.show();
            // Consent toast: treat any close (X or timeout) as "dismissed"
            if (opts && opts.consent) {
                var allowBtn = wrapper.querySelector('#global-notify-allow');
                var denyBtn = wrapper.querySelector('#global-notify-deny');
                if (allowBtn) allowBtn.addEventListener('click', async function () {
                    try { var p = await Notification.requestPermission(); if (p === 'granted') { try { if (window.startNotifications) await window.startNotifications(); } catch (e) {} } } catch (e) {}
                    try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                    try { t.hide(); } catch (e) {}
                });
                if (denyBtn) denyBtn.addEventListener('click', function () {
                    try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                    try { t.hide(); } catch (e) {}
                });
                // X dugme ili automatsko zatvaranje — tretiraj kao "odbijeno"
                wrapper.addEventListener('hidden.bs.toast', function () {
                    try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                    wrapper.remove();
                });
            } else {
                wrapper.addEventListener('hidden.bs.toast', function () { wrapper.remove(); });
            }
            return t;
        }
    };

    // Expose helper to delete a user (used by Admin Users page)
    window.deleteUser = function (userId, btn) {
        if (!confirm('Are you sure you want to delete this user?'))
            return;
        const tokenEl = document.querySelector('input[name="__RequestVerificationToken"]');
        const token = tokenEl ? tokenEl.value : null;
        fetch('?handler=Delete', {
            method: 'POST',
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, token ? { 'RequestVerificationToken': token } : {}),
            body: JSON.stringify({ id: userId })
        }).then(function (r) {
            return r.json();
        }).then(function (data) {
            if (data && data.success) {
                try { btn.closest('.user-row').remove(); } catch (e) { /* ignore */ }
                window.toasts.show('Success', data.message || 'User deleted', 'success');
            } else {
                window.toasts.show('Error', (data && data.message) ? data.message : 'Delete failed', 'error');
            }
        }).catch(function (e) {
            window.toasts.show('Error', 'Delete failed', 'error');
        });
    };

    // Back to top button
    var backBtn = document.getElementById('backToTop');
    if (backBtn) {
        window.addEventListener('scroll', function () {
            var y = window.scrollY || document.documentElement.scrollTop;
            // use classes instead of inline style for display
            if (y > 300) backBtn.classList.add('visible'); else backBtn.classList.remove('visible');
        });
        backBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }

    // Progress bar for navigation and async forms
    var progress = document.getElementById('progressbar');
    function setProgress(p) {
        if (!progress)
            return;
        var bar = progress.querySelector('.progress-bar');
        if (!bar) return;
        // Map percentage to nearest 5
        var pct = Math.max(0, Math.min(100, Math.round(p)));
        var rounded = Math.round(pct / 5) * 5;
        // remove existing progress-w-* classes
        var clsToRemove = Array.from(bar.classList).filter(c => c.startsWith('progress-w-'));
        clsToRemove.forEach(c => bar.classList.remove(c));
        bar.classList.add('progress-w-' + rounded);
        if (p > 0 && p < 100) progress.classList.add('active'); else progress.classList.remove('active');
    }

    // New startProgress: slower, non-linear increments and linger on completion
    function startProgress() {
        setProgress(10);
        var i = 10;
        var stopped = false;
        function rand(min, max) { return Math.random() * (max - min) + min; }

        var iv = setInterval(function () {
            if (stopped) return;
            var delta;
            if (i < 30) delta = rand(2.0, 5.0);          // initial quick ramp
            else if (i < 60) delta = rand(1.0, 2.5);     // moderate
            else if (i < 85) delta = rand(0.25, 1.0);    // slow
            else delta = rand(0.05, 0.35);               // very slow, approaches a stall near 99

            i = Math.min(99.4, i + delta);
            setProgress(i);
        }, 200); // tick every 200ms for visible progression

        return function stop() {
            stopped = true;
            clearInterval(iv);
            // push to complete and keep visible a bit longer so user can see it
            setProgress(100);
            // linger visible for 1500ms then reset
            setTimeout(function () { setProgress(0); }, 1500);
        };
    }

    // Link clicks (internal) -> progress (simplified and robust)
    document.addEventListener('click', function (e) {
        try {
            var a = e.target.closest('a');
            if (!a) return;
            var url = a.getAttribute('href') || '';

            // Smooth-scroll for same-page hash anchors
            if (url.startsWith('#')) {
                if (url === '#') return;
                var id = url.substring(1);
                var target = document.getElementById(id) || document.querySelector('[name="' + id + '"]');
                if (!target) return;
                e.preventDefault();
                // If navbar collapse is open, close it first then scroll
                var navCollapse = a.closest('.navbar-collapse');
                var closeAndScroll = function () {
                    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { location.hash = url; }
                    try { if (history && history.pushState) history.pushState(null, '', url); else location.hash = url; } catch (e) { location.hash = url; }
                };
                if (navCollapse && navCollapse.classList.contains('show') && typeof bootstrap !== 'undefined') {
                    try { bootstrap.Collapse.getOrCreateInstance(navCollapse).hide(); } catch (e) { }
                    // wait a short time for collapse animation to finish
                    setTimeout(closeAndScroll, 220);
                } else {
                    closeAndScroll();
                }
            }
        } catch (e) { /* ignore click handler errors */ }
    });

    // Forms -> progress + disable button
    document.addEventListener('submit', function (e) {
        var form = e.target;
        var btn = form.querySelector('button[type="submit"]');
        var stop = startProgress();
        if (btn) {
            btn.disabled = true;
            btn.dataset._old = btn.innerHTML;
            btn.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Working...';
        }
        window.addEventListener('pageshow', function () {
            if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset._old; }
            stop();
        }, {
            once: true
        });
    }, true);

  // IntersectionObserver reveal
  document.addEventListener("DOMContentLoaded", function () {
    const revealEls = document.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target); // reveal once
          }
        });
      }, {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.1
      });

      revealEls.forEach(el => observer.observe(el));
    } else {
      revealEls.forEach(el => el.classList.add('visible'));
    }
  });


  if (window.jQuery) {
    (function ($) {
      $(function () {
        $(document).on('invalid-form.validate', function (event, validator) {
          const count = validator.numberOfInvalids();
          if (count > 0) {
            const msg = `${count} field${count > 1 ? 's' : ''} need attention.`;
            window.toasts.show('Please fix form', msg, 'error');
          }
        });
      });
    })(window.jQuery);
  }


    // TempData-driven toasts via data attributes
    document.querySelectorAll('[data-toast]').forEach(function (n) {
        try {
            var tmsg = n.getAttribute('data-toast') || (n.textContent || '').trim();
            var consentSnippets = [
                'Enable browser notifications to receive push messages',
                'Use the browser UI to allow notifications'
            ];
            var isConsent = consentSnippets.some(function (s) { return tmsg && tmsg.indexOf(s) !== -1; });
            if (isConsent) {
                // If consent message, do not show the simple data-toast — global toast handles consent
                return;
            }
            window.toasts.show(
                n.getAttribute('data-title'),
                tmsg,
                n.getAttribute('data-type'));
        } catch (e) { /* ignore individual toast failures */ }
    });

    // Centralized toast logic: show TempData toast and consent toast (if needed)
    document.addEventListener('DOMContentLoaded', function () {
        // Show consent toast if needed (only once per session, with delay, and any close = dismissed)
        showConsentToastIfNeeded();
        // Show TempData toast if present and not a consent message
        var consentSnippets = [
            'Enable browser notifications to receive push messages',
            'Use the browser UI to allow notifications'
        ];
        var message = null, type = null;
        var body = document.body;
        if (body && body.dataset && body.dataset.toastMessage) {
            message = body.dataset.toastMessage;
            type = body.dataset.toastType || 'info';
        }
        if (message && message.trim().length > 0) {
            var isConsentMsg = consentSnippets.some(function (s) { return message.indexOf(s) !== -1; });
            if (!isConsentMsg) {
                window.toasts.show(type.charAt(0).toUpperCase() + type.slice(1), message, type);
            }
        }
        try {
            if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                // user's reduced motion preference - quickly show content
                document.querySelectorAll('.animated-text').forEach(function (el) { el.classList.add('visible'); });
            } else {
                // run the word wrapping/animation initializer
              if (typeof window.__wrapAnimatedText === 'function')
                window.__wrapAnimatedText();
            }
        } catch (e) { /* ignore */ }

        // Ensure the global consent toast with buttons is visible when appropriate.
        try {
            var globalToastEl = document.getElementById('global-notify-toast');
            var globalContainer = document.getElementById('global-notify-container');
            if (!globalContainer) {
                try {
                    globalContainer = document.createElement('div');
                    globalContainer.id = 'global-notify-container';
                    globalContainer.className = 'position-fixed bottom-0 end-0 p-3';
                    globalContainer.style.zIndex = '1080';
                    document.body.appendChild(globalContainer);
                } catch (e) { globalContainer = null; }
            }
            // If the global consent toast element is missing or lacks buttons, create it inside the container
            if (globalContainer && !globalToastEl) {
                try {
                    var created = document.createElement('div');
                    created.id = 'global-notify-toast';
                    created.className = 'toast';
                    created.setAttribute('role', 'alert');
                    created.setAttribute('aria-live', 'assertive');
                    created.setAttribute('aria-atomic', 'true');
                    created.setAttribute('data-bs-delay', '0');
                    created.innerHTML = [
                        '<div class="toast-header">',
                        '  <strong class="me-auto">Info</strong>',
                        '  <small class="text-muted">now</small>',
                        '  <button type="button" class="btn-close ms-2 mb-1" data-bs-dismiss="toast" aria-label="Close"></button>',
                        '</div>',
                        '<div class="toast-body d-flex align-items-center justify-content-between">',
                        '  <div>Enable browser notifications to receive push messages. Use the browser UI to allow notifications when ready.</div>',
                        '  <div class="btn-group btn-group-sm ms-3">',
                        '    <button id="global-notify-allow" class="btn btn-primary">Allow</button>',
                        '    <button id="global-notify-deny" class="btn btn-outline-secondary">No thanks</button>',
                        '  </div>',
                        '</div>'
                    ].join('\n');
                    globalContainer.appendChild(created);
                    globalToastEl = document.getElementById('global-notify-toast');
                    // Immediately wire buttons on the newly created toast to avoid timing issues
                    try {
                        var immedAllow = created.querySelector('#global-notify-allow');
                        var immedDeny = created.querySelector('#global-notify-deny');
                        var immedClose = created.querySelector('[data-bs-dismiss="toast"], .btn-close');
                        if (immedAllow && !immedAllow.dataset._wired) {
                            immedAllow.addEventListener('click', async function () {
                                try { var p = await Notification.requestPermission(); if (p === 'granted') { try { if (window.startNotifications) await window.startNotifications(); } catch (e) {} } } catch (e) {}
                                try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                                try { var bs2 = (window.bootstrap) ? new bootstrap.Toast(globalToastEl, { autohide: false }) : null; if (bs2) bs2.hide(); } catch (e) {}
                            });
                            immedAllow.dataset._wired = '1';
                        }
                        if (immedDeny && !immedDeny.dataset._wired) {
                            immedDeny.addEventListener('click', function () {
                                try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) {}
                                try { var bs3 = (window.bootstrap) ? new bootstrap.Toast(globalToastEl, { autohide: false }) : null; if (bs3) bs3.hide(); } catch (e) {}
                            });
                            immedDeny.dataset._wired = '1';
                        }
                        if (immedClose && !immedClose.dataset._wired) {
                            immedClose.addEventListener('click', function () { try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) { } });
                            immedClose.dataset._wired = '1';
                        }
                        console.log('[site] created global notify and wired buttons');
                    } catch (e) { /* ignore wiring errors */ }
                } catch (e) { /* ignore creation errors */ }
            }
            var dismissed = false;
            try { dismissed = localStorage.getItem('global_notify_shown_v1') === '1'; } catch (e) { dismissed = false; }

            // Show global consent toast when not dismissed so the button toast is always available
            if (globalToastEl && !dismissed) {
                try {
                    var bs = (window.bootstrap) ? new bootstrap.Toast(globalToastEl, { autohide: false }) : null;
                    // Wire buttons (idempotent)
                    var btnAllow = document.getElementById('global-notify-allow');
                    var btnDeny = document.getElementById('global-notify-deny');
                    var closeBtn = globalToastEl.querySelector('[data-bs-dismiss="toast"], .btn-close');

                    if (btnAllow && !btnAllow.dataset._wired) {
                        btnAllow.addEventListener('click', async function () {
                            try {
                                var p = await Notification.requestPermission();
                                if (p === 'granted') {
                                    try { if (window.startNotifications) await window.startNotifications(); } catch (e) { }
                                }
                            } catch (e) { }
                            try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) { }
                            try { if (bs) bs.hide(); } catch (e) { }
                        });
                        btnAllow.dataset._wired = '1';
                    }
                    if (btnDeny && !btnDeny.dataset._wired) {
                        btnDeny.addEventListener('click', function () {
                            try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) { }
                            try { if (bs) bs.hide(); } catch (e) { }
                        });
                        btnDeny.dataset._wired = '1';
                    }
                    if (closeBtn && !closeBtn.dataset._wired) {
                        closeBtn.addEventListener('click', function () { try { localStorage.setItem('global_notify_shown_v1', '1'); } catch (e) { } });
                        closeBtn.dataset._wired = '1';
                    }

                    try { if (bs) bs.show(); } catch (e) { }
                } catch (e) { /* ignore show errors */ }
            }
        } catch (e) { /* ignore */ }
    });

    // Star-rating click handler (keeps rating logic centralized)
    if (window.jQuery) {
        (function ($) {
            $(function () {
                $('.star-rating .star').on('click', function () {
                    var $star = $(this);
                    var value = $star.data('value');
                    var $container = $star.closest('.star-rating');
                    var projectId = $container.data('project-id');
                    var blogId = $container.data('blog-id');

                    // Highlight selected stars
                    $container.find('.star').each(function () {
                        $(this).toggleClass('selected', $(this).data('value') <= value);
                    });

                    // Determine endpoint and payload consistently
                    var isProject = typeof projectId !== 'undefined' && projectId !== false && projectId !== null;
                    var endpoint = isProject ? '/api/rate' : '/api/blograte';
                    var payload = isProject
                        ? { projectId: projectId, stars: value }
                        : { blogId: blogId, stars: value };
                    $.ajax({
                        url: endpoint,
                        method: 'POST',
                        contentType: 'application/json; charset=utf-8',
                        data: JSON.stringify(payload),
                        success: function (resp) {
                            try {
                                var $avg = $container.siblings('.avg-rating').first();
                                if (!$avg.length) $avg = $container.find('.avg-rating').first();
                                if ($avg.length && resp && resp.average)
                                    $avg.text(parseFloat(resp.average).toFixed(1) + ' /5');
                            }
                            catch (e) { /* ignore */ }
                            window.toasts?.show('Success', 'Thank you for your rating!', 'success');
                        },
                        error: function (xhr) {
                            if (xhr && xhr.status === 409) {
                                window.toasts?.show('Notice', 'You have already rated this item.', 'info');
                                return;
                            }
                            let msg = 'Could not submit rating.';
                            try {
                                var body = xhr && xhr.responseJSON ? xhr.responseJSON : (xhr && xhr.responseText ? JSON.parse(xhr.responseText) : null);
                                if (body && body.error) msg = body.error;
                            } catch (e) { /* ignore parse errors */ }
                            window.toasts?.show('Error', msg, 'error');
                        }
                    });
                });
            });
        })(window.jQuery);
    }


    // Example starter JavaScript for disabling form submissions if there are invalid fields
    if (window.jQuery) {
        $(function () {
            $("form.needs-validation").on("submit", function (event) {
                var form = $(this);
                if (form[0].checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.addClass('was-validated');
                form.find('.form-control').each(function () {
                    if (!this.checkValidity()) {
                        $(this).addClass('is-invalid');
                    }
                    else {
                        $(this).removeClass('is-invalid');
                    }
                });
            });
        });
    }


    window.__wrapAnimatedText = function () {
        var containers = document.querySelectorAll('.animated-text');
        if (!containers || containers.length === 0) return;

        containers.forEach(function (container) {
            function wrapTextNodes(node, startIndex) {
                var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
                    acceptNode: function (txt) {
                        return /\S/.test(txt.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                    }
                });
                var textNodes = [];
                while (walker.nextNode())
                    textNodes.push(walker.currentNode);

                var globalIndex = startIndex || 0;
                textNodes.forEach(function (txt) {
                    var parent = txt.parentNode;
                    var parts = txt.nodeValue.split(/(\s+)/); // keep whitespace
                    var frag = document.createDocumentFragment();
                    parts.forEach(function (p) {
                        if (p.trim().length === 0) {
                            frag.appendChild(document.createTextNode(p));
                        } else {
                            var span = document.createElement('span');
                            span.className = 'word';
                            span.textContent = p;
                            // do not set inline animationDelay; we'll add 'word-visible' class later with JS timeouts
                            frag.appendChild(span);
                            globalIndex++;
                        }
                    });
                    parent.replaceChild(frag, txt);
                });
                return globalIndex;
            }
            try {
                var total = wrapTextNodes(container, 0);
                // Force reflow then add class to start animations, stagger by adding class per-word without inline styles
                void container.offsetWidth;
                var words = container.querySelectorAll('.word');
                words.forEach(function (w, idx) {
                    setTimeout(function () { w.classList.add('word-visible'); }, Math.min(80 * idx, 700));
                });
                container.classList.add('animated-started');
            } catch (e) {
                // If something goes wrong, fall back to a simple fade via class
                try { container.classList.add('visible'); } catch (e) { /* ignore */ }
            }
        });
    };


})();
